import * as React from "react";
import { BreadcrumbTemplateEnum, Breadcrumbs, Page, PageInner, PageHeader, PageSection } from "@app/shared";
import AddExceptionsFlyout from "./AddExceptionsFlyout";
import FlyoutLink from "@app/shared/Flyouts/FlyoutLink";
import { DocumentTypes } from "./documentTypesEnum";
import SpecialtyExceptionsService from "./specialtyExceptionsService";
import { toast } from "react-toastify";
import { QESButton } from "../../shared/qes-standards";
import { QesIcons } from "@app/shared/icons/qesIcons";

const CmsTemplate: React.FC = () => {
  const specialtyExceptionsService = React.useMemo(() => new SpecialtyExceptionsService(), []);

  const handleDownload = async (documentType: DocumentTypes) => {
    try {
      const documentUrl = await specialtyExceptionsService.downloadCmsExceptionTemplate(documentType);
      window.open(documentUrl, "_blank");
    } catch (error) {
      toast.error(<span>No template file found.</span>, {
        containerId: "z-index-9999",
      });
    }
  };

  const renderUploadButton = (documentType: DocumentTypes) => (
    <FlyoutLink
      content={{
        body: (
          <AddExceptionsFlyout
            container="your-container-name"
            fileExtensionSplitter={(filename) => {
              const parts = filename.split(".");
              return [parts.slice(0, -1).join("."), parts[parts.length - 1]];
            }}
            onUpload={(displayTitle) => {
              toast.success(<span>File &quot;{displayTitle}&quot; successfully uploaded</span>, {
                containerId: "z-index-9999",
              });
            }}
            documentType={documentType}
          />
        ),
        title: "Add Exception File",
      }}
      classNames="qes-button-secondary"
      testId="add-exception__add-new-flyout"
      size="40"
    >
      <i className="fa fa-plus pr5" /> Upload
    </FlyoutLink>
  );

  const renderSection = (title: string, documentType: DocumentTypes) => (
    <PageSection>
      <div className="d-flex flex-row align-items-center w-100 pb10 pt10 grid-row">
        <div className="ml10 mb0 flex-grow" style={{ fontWeight: "normal" }}>{title}</div>
      </div>
      <div className="d-flex flex-row align-items-center w-100 pb10 pt10 grid-row">
        <div className="d-flex" style={{ gap: "10px" }}>
          {renderUploadButton(documentType)}
          <QESButton qesType="secondary" qesTestId="cms-template__download" onClick={() => handleDownload(documentType)}>
            <i className="fa fa-download pr5" /> Download
          </QESButton>
        </div>
      </div>
    </PageSection>
  );

  return (
    <Page documentTitle="Manage Specialty Exception Templates">
      <Breadcrumbs
        template={BreadcrumbTemplateEnum.Admin}
        items={[
          {
            iconClass: "fa-file-pdf-o",
            text: "Manage Specialty Exception Templates",
          },
        ]}
      />
      <PageInner>
        <PageHeader title="Manage Specialty Exception Templates" iconName={QesIcons.FontAwesome.FilePdfOutline}></PageHeader>

        {renderSection("CMS MA", DocumentTypes.CmsMa)}
        {renderSection("CMS MA CONTINUED", DocumentTypes.CmsMaContinued)}
        {renderSection("CMS MMP", DocumentTypes.CmsMmp)}
        {renderSection("CMS MMP CONTINUED", DocumentTypes.CmsMmpContinued)}

      </PageInner>
    </Page>
  );
};

export default CmsTemplate;
